import React, { useState } from "react";
import { useSelector } from "react-redux";
import CurrentProcesses from "./current";
import { EmployeesProcesses } from "@icarius-pages/employeesProcesses";
import { getTemplates } from "../selectors";

const CurrentProcessesSwitch = () => {

  const [employeesIsOpen, setEmployeesIsOpen] = useState(false);
  const [process, setProcess] = useState(null);
  const templates = useSelector(getTemplates);

  const handleOpenEmployeesPage = (process) => {
    setProcess(process);
    setEmployeesIsOpen(true);
  }

  return (
    <>
      {
        employeesIsOpen ?
          <EmployeesProcesses
            process={process}
            templates={templates}
            handleGoBack={() => setEmployeesIsOpen(false)}
          />
          :
          <CurrentProcesses
            handleOpenEmployeesPage={handleOpenEmployeesPage}
          />
      }
    </>
  );
}

export default CurrentProcessesSwitch;
